import { useState } from "react";
import { useQuery } from "wasp/client/operations";
import { getMySocialReports } from "wasp/client/operations";
import { Button } from "../client/components/ui/button";
import { Plus } from "lucide-react";
import useTranslation from "../client/hooks/useTranslation";
import { GenerateReportDialog } from "./components/GenerateReportDialog";
import { ReportsList } from "./components/ReportsList";

export default function ReportsPage() {
  const t = useTranslation();
  const [genOpen, setGenOpen] = useState(false);
  const { data, refetch } = useQuery(getMySocialReports);

  const isEmpty = !data || data.length === 0;

  return (
    <div className="w-full px-4 py-6 space-y-6">
      <div className="flex flex-row items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">{t.reports.pageTitle}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t.reports.pageSubtitle}</p>
        </div>
        <Button onClick={() => setGenOpen(true)} size="default">
          <Plus className="h-4 w-4 mr-2" />
          {t.reports.generateCta}
        </Button>
      </div>

      {isEmpty ? (
        <div className="flex flex-col items-center justify-center py-16 gap-4 text-center">
          <p className="text-muted-foreground">{t.reports.emptyState}</p>
          <Button onClick={() => setGenOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            {t.reports.emptyStateCta}
          </Button>
        </div>
      ) : (
        <ReportsList />
      )}

      <GenerateReportDialog open={genOpen} onOpenChange={setGenOpen} onGenerated={refetch} />
    </div>
  );
}
